"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  '/login': {
    title: 'Login page',
    view: 'Login',
    layout: "Auth",
    "public": true,
    locales: {
      az: '/az/login',
      en: '/en/login',
      ru: '/ru/login'
    }
  },
  '/az/login': {
    ref: '/login',
    lang: 'az',
    title: 'Daxil ol'
  },
  '/en/login': {
    ref: '/login',
    lang: 'en',
    title: 'Log in'
  },
  '/ru/login': {
    ref: '/login',
    lang: 'ru',
    title: 'Авторизации'
  },
  '/cabinet': {
    title: 'Personal cabinet',
    view: 'Cabinet',
    locales: {
      az: '/az/cabinet',
      en: '/en/cabinet',
      ru: '/ru/cabinet'
    }
  },
  '/az/cabinet': {
    ref: '/cabinet',
    lang: 'az',
    title: 'Şəxsi kabinet'
  },
  '/en/cabinet': {
    ref: '/cabinet',
    lang: 'en',
    title: 'Personal cabinet'
  },
  '/ru/cabinet': {
    ref: '/cabinet',
    lang: 'ru',
    title: 'Личный кабинет'
  },
  '/cabinet/password': {
    title: 'Change password',
    view: 'CabinetPassword',
    locales: {
      az: '/az/cabinet/password',
      en: '/en/cabinet/password',
      ru: '/ru/cabinet/password'
    }
  },
  '/az/cabinet/password': {
    ref: '/cabinet/password',
    lang: 'az',
    title: 'Şifrəni dəyişdir'
  },
  '/en/cabinet/password': {
    ref: '/cabinet/password',
    lang: 'en',
    title: 'Change password'
  },
  '/ru/cabinet/password': {
    ref: '/cabinet/password',
    lang: 'ru',
    title: 'Сменить пароль'
  }
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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